import { PopupShare } from '@atlassian/learning-components';
import React from 'react';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';

export const ShareArticleButton: React.FC = () => {
  const url = window.location.href;

  return (
    <div css={shareArticleStyles}>
      <PopupShare alignToLeft urlToShare={url} buttonText="Share article" />
    </div>
  );
};

const shareArticleStyles = css({
  display: 'flex',
  alignItems: 'center',
  gap: token('space.050'),
});
